import React from 'react';
import { AllieTextWrapperMessage } from '../../ChatResponse.styles';
import { parseTextResponse } from '../../../../../common/utils';
import { AllieColors } from '../../../../../common/color.types';
import { useTypewriter } from '../../hooks/useTypewriter';

interface TypewriterTextProps {
  message: string;
  textColor?: AllieColors;
  animateResponse?: boolean;
  maxDuration?: number;
  maxSpeed?: number;
  onRenderComplete?: () => void;
  parseFunction?: (text: string) => React.ReactNode;
}

export const TypewriterText: React.FC<TypewriterTextProps> = ({
  message,
  textColor = 'neutral-90',
  animateResponse = false,
  maxDuration = 3000,
  maxSpeed = 100,
  onRenderComplete,
  parseFunction,
}) => {
  const { displayedText } = useTypewriter({
    text: message,
    maxDuration,
    maxSpeed,
    enabled: animateResponse,
    onComplete: onRenderComplete,
  });

  // Use custom parse function if provided, otherwise use default
  const parsedContent = displayedText
    ? parseFunction 
      ? parseFunction(displayedText)
      : parseTextResponse(displayedText)
    : '';

  return <>{parsedContent}</>;
}; 